import { render, staticRenderFns } from "./tradingOrder.vue?vue&type=template&id=1f443dba&scoped=true"
import script from "./tradingOrder.vue?vue&type=script&lang=js"
export * from "./tradingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f443dba",
  null
  
)

export default component.exports